import clsx from 'clsx';
import type { ReactNode } from 'react';
import styles from './MetaList.module.css';

export interface MetaItem {
  readonly id: string;
  readonly label: string;
  readonly value: ReactNode;
}

/** Label/value facts, e.g. duration and resolution of a film. */
export const MetaList = ({
  items,
  className,
}: {
  readonly items: readonly MetaItem[];
  readonly className?: string | undefined;
}) => (
  <dl className={clsx(styles.list, className)}>
    {items.map((item) => (
      <div key={item.id} className={styles.item}>
        <dt className={styles.label}>{item.label}</dt>
        <dd className={styles.value}>{item.value}</dd>
      </div>
    ))}
  </dl>
);
